import { render } from "./ListChannels.vue?vue&type=template&id=9016abf2&ts=true"
import script from "./ListChannels.vue?vue&type=script&lang=ts"
export * from "./ListChannels.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Special/ListChannels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9016abf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9016abf2', __exports__)) {
    api.reload('9016abf2', __exports__)
  }
  
  module.hot.accept("./ListChannels.vue?vue&type=template&id=9016abf2&ts=true", () => {
    api.rerender('9016abf2', render)
  })

}


export default __exports__